/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackDownloadCountResponseData } from './TrackDownloadCountResponseData';
import {
    TrackDownloadCountResponseDataFromJSON,
    TrackDownloadCountResponseDataFromJSONTyped,
    TrackDownloadCountResponseDataToJSON,
} from './TrackDownloadCountResponseData';

/**
 * 
 * @export
 * @interface TrackDownloadCountsResponse
 */
export interface TrackDownloadCountsResponse {
    /**
     * 
     * @type {Array<TrackDownloadCountResponseData>}
     * @memberof TrackDownloadCountsResponse
     */
    data: Array<TrackDownloadCountResponseData>;
}

/**
 * Check if a given object implements the TrackDownloadCountsResponse interface.
 */
export function instanceOfTrackDownloadCountsResponse(value: object): value is TrackDownloadCountsResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrackDownloadCountsResponseFromJSON(json: any): TrackDownloadCountsResponse {
    return TrackDownloadCountsResponseFromJSONTyped(json, false);
}

export function TrackDownloadCountsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackDownloadCountsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TrackDownloadCountResponseDataFromJSON)),
    };
}

export function TrackDownloadCountsResponseToJSON(value?: TrackDownloadCountsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(TrackDownloadCountResponseDataToJSON)),
    };
}

